import { INVITATION_URL_QUERY_KEY } from '@core/livestream/constants'

/**
 * Lazy load guest speaker invitation if the url contains invitation url query key.
 */
export const loadInvitationLazy = () => {
  if (typeof window === 'undefined') {
    return
  }

  if (window.location.href.includes(INVITATION_URL_QUERY_KEY)) {
    import('./loadInvitation').then(({ loadInvitation }) => {
      loadInvitation()
    })
  }
}
